<div class="pad-L" style="height: 100%; width: 435px; overflow: hidden;">
	<div class="disp-f j-c-s a-i-c">
		<div>
			<div class="disp-f a-i-c j-c-c col bkg-light-grey-2 radius-10"
				 style="height: 45px; width: 45px;">
				<img alt="" src="assets/icons/user-edit.svg" class="svg-24 filter-grey">
			</div>
		</div>
		<div class="ml-s flex-column gap-XS">
			<div class="font-L fw-700">{{ 'page.settings.editProfile2' | translate }}</div>
			<div class="font-M fw-300">{{ 'page.settings.editProfileSubtitle' | translate }}</div>
		</div>
		<app-icon-button (click)="closeDialog(false)" class="ml-auto" [img]="'assets/icons/close.svg'" type="stroked"
						 background [panelClass]="'img-size-30 darken-icon'"></app-icon-button>
	</div>
	<form [formGroup]="formGroup">
		<div class="hr-document mt-l"></div>
		<div class="flex-column gap-XS mt-l">
			<div class="font-M fw-500 grey">{{ 'page.settings.firstName' | translate }}*</div>
			<app-text-input *ngIf="initialized" [input]="$any(formGroup.get('firstName'))" (keydown.enter)="submit()"></app-text-input>
		</div>
		<div class="flex-column gap-XS mt-l">
			<div class="font-M fw-500 grey">{{ 'page.settings.lastName' | translate }}*</div>
			<app-text-input *ngIf="initialized" [input]="$any(formGroup.get('lastName'))" (keydown.enter)="submit()"></app-text-input>
		</div>
		<div class="hr-document mt-l"></div>
		<div class="flex gap-M mt-l">
			<app-text-button type="stroked" class="w-50" [disabled]="_saving"
							 (click)="closeDialog(false)">
				{{ 'button.cancel' | translate }}
			</app-text-button>
			<app-text-button type="flat" class="w-50" [disabled]="formGroup.invalid" [loading]="_saving"
							 (click)="submit()">
				{{ 'button.confirm' | translate }}
			</app-text-button>
		</div>
	</form>
</div>
